export default {
      id: "minds-usage",
      viewBox: "0 0 352 512",
      url: __webpack_public_path__ + "img/svg.c2d72070.svg#minds",
      toString: function () {
        return this.url;
      }
    }